<template>
    <div>
        <v-navigation-drawer
            :width="isMobile ? '100%' : '320px'"
            v-model="drawer"
            class="side_menu"
            floating
            :stateless="$vuetify.breakpoint.mdAndUp"
            hide-overlay
            app
        >
            <v-row class="sidebar_content px-5 px-sm-10 flex-column flex-nowrap">
                <div class="d-flex mt-5 mt-sm-14 my-sm-10 mb-sm-6 justify-between">
                    <v-col class="d-md-none">
                        <v-app-bar-nav-icon class="menu_btn ml-n3" @click="drawer = false">
                            <img src="../assets/menu.svg" alt="menu" />
                        </v-app-bar-nav-icon>
                    </v-col>
                    <v-col class="d-flex align-center pl-md-1"
                    ><router-link class="logo" to="/dashboard">
                        <img
                            :width="isMobile ? '186px' : '232px'"
                            src="../assets/logo.svg"
                            alt="Soclikes Logo"
                        /> </router-link
                    ></v-col>
                </div>

                <v-list rounded nav>
                    <v-list-item-group active-class="active_btn">
                        <template v-for="(item, index) in items">
                            <v-list-item
                                class="side_menu_btn"
                                :key="item.route + index"
                                link
                                :to="item.route"
                            >
                                <img v-if="item.icon" class="menu_item_icon" :src="item.icon" :alt="item.name" />
                                <v-list-item-content>
                                    {{ item.name }}
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                    </v-list-item-group>
                </v-list>
                <v-spacer class="d-block d-md-none"></v-spacer>
                <BreadCrumbs class="d-flex d-md-none mb-2 ml-n4" />
            </v-row>
        </v-navigation-drawer>
        <v-app-bar
            absolute
            height="88"
            app
            class="app_bar elevation-0 mx-md-6 my-2 my-sm-5 mb-sm-0"
            color="transparent"
            :style="{ zIndex: $parent.tour ? '999' : '2' }"
        >
            <Alert v-if="alert" :item="alert" @update="closeAlert" />

            <v-app-bar-nav-icon
                class="menu_btn d-md-none ml-n2"
                @click="drawer = true"
            >
                <img src="../assets/menu.svg" alt="menu" />
            </v-app-bar-nav-icon>
            <BreadCrumbs class="d-none d-md-flex" />
            <v-spacer></v-spacer>
            <v-btn
                color="#eef4ff"
                icon
                width="60"
                height="60"
                class="notification_btn mr-1 mr-lg-6"
                @click="notifications_opened = notifications_opened === true ? false : true"
                ref="notification"
            >
                <v-fade-transition>
                    <Notifications v-if="notifications_opened" />
                </v-fade-transition>

                <div class="new_messages"></div>
                <img
                    style="z-index: 999"
                    src="../assets/notification.svg"
                    alt="notifications"
                />
            </v-btn>

            <UserMenu @close_otification="hideNotifications" />
        </v-app-bar>
    </div>
</template>

<script>
    import BreadCrumbs from "../components/BreadCrumbs.vue";
    import Notifications from "../components/Notifications.vue";
    import Alert from "../components/Alert.vue";
    import UserMenu from "./UserMenu.vue";

    export default {
        name: "Header",
        components: {
            BreadCrumbs,
            Notifications,
            Alert,
            UserMenu,
        },
        data() {
            return {
                drawer: false,
                isMobile: false,
                notifications_opened: false,
                // alert: {
                //   type: "success_alert",
                //   title: "Notif title",
                //   text: "Text",
                // },
                // alert: {
                //   type: "error_alert",
                //   title: "Notif title",
                //   text: "Text",
                // },
                // alert: {
                //   type: "warn_alert",
                //   title: "Notif title",
                //   text: "Text",
                // },
                alert: null,
                items: [
                    {
                        name: "Home",
                        icon: "../assets/home.svg",
                        route: "/dashboard",
                    },
                    {
                        name: "Instagram",
                        icon: "../assets/instagram.svg",
                        route: "/account/instagram",
                    },
                    {
                        name: "Tiktok",
                        icon: "../assets/tik-tok.svg",
                        route: "/account/tiktok",
                    },
                    {
                        name: "Orders",
                        icon: "../assets/trolley.svg",
                        route: "/orders",
                    },
                    {
                        name: "Billing",
                        icon: "../assets/subscriptions-ico.svg",
                        route: "/biling",
                    },
                    // {
                    //     name: "Subscriptions",
                    //     icon: "../assets/exchange.svg",
                    //     route: "/subscriptions",
                    // },
                  {
                    name: "Notifications",
                    icon: "../assets/notification-menu.svg",
                    route: "/notification",
                  },
                ],
            };
        },
        beforeDestroy() {
            if (typeof window === "undefined") return;

            window.removeEventListener("resize", this.onResize, { passive: true });
        },

        mounted() {
            this.onResize();
            window.addEventListener("resize", this.onResize, { passive: true });
            window.addEventListener("click", this.handleClick);
        },

        methods: {
            onResize() {
                this.isMobile = window.innerWidth < 960;
                if (window.innerWidth > 960) {
                    this.drawer = true;
                }
            },
            closeAlert(val) {
                this.alert = val;
            },
            handleClick(ev) {
                if (!this.notifications_opened) return;
                const el = this.$refs.notification.$el;
                if (!el.contains(ev.target) && ev.target !== el) {
                    this.hideNotifications();
                }
            },
            hideNotifications() {
                this.notifications_opened = false;
            },
        },
    };
</script>
<style scoped>
    .app_bar {
        background-color: #eef4ff !important;
        border-radius: 20px !important;
    }
    .menu_btn {
        height: 60px !important;
        width: 60px !important;
    }
    .side_menu {
        border-radius: 0px 20px 20px 0px;
        border: none;
    }
    .sidebar_content {
        height: 100%;
    }
    .sidebar_content .v-list {
        width: 100%;
    }
    .side_menu_btn {
        height: 60px;
        border-radius: 40px;
        color: #2c4370 !important;
        font-weight: 600;
        font-size: 18px !important;
    }
    .active_btn {
        background-color: #f1f6ff;
        color: #2c4370 !important;
    }
    .v-list-item--link:before {
        opacity: 0 !important;
    }
    .notification_btn {
        background-color: #fff;
        position: relative;
    }
    .menu_item_icon {
        width: 20px;
        height: 20px;
        margin-left: 25px;
        margin-right: 9px;
        margin-bottom: 2px;
    }
    .side_menu_btn:nth-child(4n) .menu_item_icon {
        margin-bottom: 7px;
    }
</style>
